// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"851ab2ad","455":"8a534faf","977":"ed823129"}[chunkId] + ".chunk.js";
};